export default __webpack_public_path__ + "static/media/bezel_set.a4aa71cc.webp";